import React, { useEffect, useState } from 'react'
import Map from "./LocationMap"
import { fromInfo, trans } from '../../../../_providers/Translation'

//styles
import '../../../../assets/css/leeflet.css'
import Help from '../../../partials/Help'
import { BarChart } from '@mui/x-charts/BarChart'
import Api from '@/_helpers/Api'
import { Skeleton } from '@mui/material'

const STATUSES = [
    {
        name: 'Завършени',
        color: '#3D5AFE',
    },
    {
        name: 'Незавършени',
        color: '#C5CAE9',
    }
]
function Location() {
    const [state, setState] = useState({
        loading: true,
        employees: [],
        completed: [],
        uncompleted: [],
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        Api.get('reservations/compared-data')
            .then(res => {
                const employees = res.data.employees || []
                const results = res.data.results || {}

                setState(prev => ({
                    ...prev,
                    employees: employees.map(e => e.name),
                    completed: employees.map(e => results[e.id]?.completed || 0),
                    uncompleted: employees.map(e => results[e.id]?.not_completed || 0),
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    return (
        <div className="employees-reservations-chart">
            <div className='head'>
                <h3>
                    {trans('random.workSixMonths')}
                </h3>
                <ul>
                    {STATUSES.map(status =>
                        <li key={status.name}>
                            <span style={{ background: status.color }}></span>
                            {status.name}
                        </li>
                    )}
                </ul>
            </div>
            <hr />
            {state.loading ?
                <Skeleton count={1} height={300} />
                :
                state.employees &&
                <BarChart
                    xAxis={[{
                        scaleType: 'band',
                        data: state.employees,
                    }]}
                    series={[
                        {
                            data: state.completed,
                            label: STATUSES[0].name,
                            stack: 'tasks',
                            color: STATUSES[0].color,
                        },
                        {
                            data: state.uncompleted,
                            label: STATUSES[1].name,
                            stack: 'tasks',
                            color: STATUSES[1].color,
                        },
                    ]}
                    height={300}
                    margin={{
                        right: 0
                    }}
                    borderRadius={8}
                    slotProps={{
                        legend: { hidden: true },
                    }}
                />
            }
        </div>
    )
}

export default Location